export var globals = {
    WS_URL: SINGLE_INSTANCE_MODE ? WS_URL : null,
    // eslint-disable-next-line no-undef
    API_URL: API_URL,
    CURRENT_STORE_VERSION: '1.0'
};
